/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
import { Container, MapTo } from '@adobe/aem-react-editable-components';
import {
  AccordionContainer,
  BannerLayered,
  BrandRibbon,
  CardCarouselContainer,
  CardHorizontalFeature,
  CardHorizontalMini,
  CardLayered,
  CardVertical,
  EditableHTLWrapper,
  Hero,
  LinkList,
  RichText,
  StaticWrapper,
  DynamicWrapper,
  NavigationContainerWrapper,
  NavigationUtilityLinkWrapper,
  NavigationWrapper,
  Footer,
} from '@marriott/mi-common-static-components';
import {
  AssociateHeader,
  AssociateLogin,
  BulletinBoard,
  ConfirmEventSummary,
  ContactInfo,
  CreateEventSummary,
  DashboardContentTiles,
  EventDetails,
  EventHeading,
  EventList,
  EventProfile,
  EventSearch,
  EventSpaces,
  EventSummaryList,
  GeneralError,
  GeneralMessage,
  GroupSearchFormDynamic,
  GroupSearchForm,
  SearchFormDynamic,
  SearchForm,
  GuestRooms,
  ImageBanner,
  IntlRfpEventInfo,
  IntlRfpHeader,
  ModifyEventSummary,
  NavigationMenu,
  PaymentInfo,
  PlannerEventList,
  PlannerHeader,
  PlannerLogin,
  PlannerNewEvent,
  PreferredPaymentConfirmation,
  PreferredPaymentHeader,
  PreferredPaymentInfo,
  PropertyHeader,
  QuickGroupHeader,
  ReslinkAssociateHeader,
  ReslinkDashboardContentTiles,
  ReslinkEmailInfo,
  ReslinkEventDetails,
  ReslinkGuest,
  ReslinkSearchAndFilter,
  Review,
  RfpConfirmation,
  RfpHeader,
  RfpTray,
  SearchAndFilter,
  SearchResults,
  SubmitInquiry,
  BillingAndContact,
  QuickGroupConfirmation,
  InvalidSession,
  EventConfirmationDetails,
  ResubmitRfp,
} from '@marriott/mi-groups-components';
import { respGridUtil } from '@marriott/mi-headless-utils';
import { HeroBanner } from '@marriott/mi-homepage-components';
import { FlyoutDrawer } from '@marriott/mi-book-components';
import { AccountContainerEditable, SignInEditable, SignInContentBlockEditable } from '@marriott/mi-account-components';
import { Heading, Text } from '@marriott/mi-ui-library';
import { getAllowedComponentsForNonAuthorMode as getAllowedComponentsForNonAuthorModeUtil } from '@marriott/shared/mi-helper-utils';
import '../../libs/aemComponents/Container';
import '../../libs/aemComponents/ExperienceFragment';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

export const AEM_REACT_MAPPING = {
  [`mi-aem-common-spa/components/text`]: Text,
  [`mi-aem-common-spa/components/title`]: Heading,
  [`mi-aem-common-spa/components/image`]: Container,
  [`mi-aem-common-spa/components/experiencefragment`]: Container,
  [`mi-aem-common-spa/components/common/staticwrapper`]: StaticWrapper,
  [`mi-aem-common-spa/components/content/globalnav/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-common-spa/components/content/globalnav/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-common-spa/components/content/globalnav/primaryNavigation`]: NavigationWrapper,
  [`mi-aem-common-spa/components/common/dynamicwrapper`]: DynamicWrapper,
  [`mi-aem-common-spa/components/content/brandribbon`]: BrandRibbon,
  [`mi-aem-common-spa/components/content/accordioncontainer`]: AccordionContainer,
  [`mi-aem-common-spa/components/content/linklist`]: LinkList,
  [`mi-aem-common-spa/components/content/hero`]: Hero,
  [`mi-aem-homepage-spa/components/content/herobanner`]: HeroBanner,
  [`mi-aem-homepage-spa/components/content/universal-footer`]: Footer,
  [`mi-aem-common-spa/components/content/bannerlayered`]: BannerLayered,
  [`mi-aem-common-spa/components/content/cardlayered`]: CardLayered,
  [`mi-aem-common-spa/components/content/cardvertical`]: CardVertical,
  [`mi-aem-common-spa/components/content/cardhorizontalmini`]: CardHorizontalMini,
  [`mi-aem-common-spa/components/content/cardcarouselcontainer`]: CardCarouselContainer,
  [`mi-aem-common-spa/components/content/cardhorizontalfeature`]: CardHorizontalFeature,
  [`mi-aem-common-spa/components/content/richtext`]: RichText,
  [`mi-aem-groups/components/content/shoppingpages/sectionnavigation`]: NavigationMenu,
  [`mi-aem-groups/components/content/shoppingpages/imagebanner`]: ImageBanner,
  [`mi-aem-groups/components/content/groupsearchform`]: GroupSearchForm,
  [`mi-aem-groups/components/content/groupsearch/searchresultsv2`]: SearchForm,
  [`mi-aem-groups/components/content/groupsearch/searchresults`]: SearchResults,
  [`mi-aem-groups/components/content/rfp/rfptray`]: RfpTray,
  [`mi-aem-groups/components/content/rfp/header`]: RfpHeader,
  [`mi-aem-groups/components/content/rfp/eventprofile`]: EventProfile,
  [`mi-aem-groups/components/content/rfp/eventdetails`]: EventDetails,
  [`mi-aem-groups/components/content/rfp/contactinformation`]: ContactInfo,
  [`mi-aem-groups/components/content/rfp/confirmation`]: RfpConfirmation,
  [`mi-aem-groups/components/content/rfp/eventinfoheader`]: IntlRfpHeader,
  [`mi-aem-groups/components/content/rfp/eventinfo`]: IntlRfpEventInfo,
  [`mi-aem-groups/components/content/rfp/paymentheader`]: PreferredPaymentHeader,
  [`mi-aem-groups/components/content/rfp/preferredpayment`]: PreferredPaymentInfo,
  [`mi-aem-groups/components/content/rfp/cardInformation`]: PaymentInfo,
  [`mi-aem-groups/components/content/rfp/preferredpaymentconfirmation`]: PreferredPaymentConfirmation,
  [`mi-aem-groups/components/content/roominglist/associateheader`]: AssociateHeader,
  [`mi-aem-groups/components/content/roominglist/roominglistlogin`]: AssociateLogin,
  [`mi-aem-groups/components/content/roominglist/contenttiles`]: DashboardContentTiles,
  [`mi-aem-groups/components/content/roominglist/searchandfilters`]: SearchAndFilter,
  [`mi-aem-groups/components/content/roominglist/createeventsummary`]: CreateEventSummary,
  [`mi-aem-groups/components/content/roominglist/modifyeventsummary`]: ModifyEventSummary,
  [`mi-aem-groups/components/content/roominglist/eventsummarylist`]: EventSummaryList,
  [`mi-aem-groups/components/content/roominglist/revieweventsummary`]: ConfirmEventSummary,
  [`mi-aem-groups/components/content/roominglist/planner/plannerheader`]: PlannerHeader,
  [`mi-aem-groups/components/content/roominglist/planner/plannerlogin`]: PlannerLogin,
  [`mi-aem-groups/components/content/roominglist/planner/eventheading`]: EventHeading,
  [`mi-aem-groups/components/content/roominglist/planner/search`]: EventSearch,
  [`mi-aem-groups/components/content/roominglist/planner/plannereventlist`]: PlannerEventList,
  [`mi-aem-groups/components/content/roominglist/planner/plannernewevent`]: PlannerNewEvent,
  [`mi-aem-groups/components/content/roominglist/notification`]: BulletinBoard,
  [`mi-aem-groups/components/content/reslink/reslinkguest`]: ReslinkGuest,
  [`mi-aem-groups/components/content/reslink/reslinkheader`]: ReslinkAssociateHeader,
  [`mi-aem-groups/components/content/reslink/contenttile`]: ReslinkDashboardContentTiles,
  [`mi-aem-groups/components/content/reslink/searchandfilters`]: ReslinkSearchAndFilter,
  [`mi-aem-groups/components/content/reslink/reslinklist`]: EventList,
  [`mi-aem-groups/components/content/reslink/eventdetails`]: ReslinkEventDetails,
  [`mi-aem-groups/components/content/common/emailform`]: ReslinkEmailInfo,
  [`mi-aem-groups/components/content/common/generalerror`]: GeneralError,
  [`mi-aem-groups/components/content/common/reslinksubmitinvalid`]: GeneralMessage,
  [`mi-aem-groups/components/content/quickgroup/propertycardheader`]: PropertyHeader,
  [`mi-aem-groups/components/content/quickgroup/header`]: QuickGroupHeader,
  [`mi-aem-groups/components/content/quickgroup/guestrooms`]: GuestRooms,
  [`mi-aem-groups/components/content/quickgroup/eventspaces`]: EventSpaces,
  [`mi-aem-groups/components/content/quickgroup/eventreview`]: Review,
  [`mi-aem-groups/components/content/quickgroup/billingandcontact`]: BillingAndContact,
  [`mi-aem-groups/components/content/quickgroup/submitenquiry`]: SubmitInquiry,
  [`mi-aem-groups/components/content/quickgroup/confirmation`]: QuickGroupConfirmation,
  [`mi-aem-groups/components/content/quickgroup/invalidsession`]: InvalidSession,
  [`mi-aem-groups/components/content/quickgroup/eventconfirmationdetails`]: EventConfirmationDetails,
  [`mi-aem-groups/components/content/quickgroup/resubmitrfp`]: ResubmitRfp,
  [`mi-aem-homepage-spa/components/content/global-navigation`]: NavigationContainerWrapper,
  [`mi-aem-homepage-spa/components/content/utilityNavigation`]: NavigationUtilityLinkWrapper,
  [`mi-aem-homepage-spa/components/content/primaryNavigation`]: NavigationWrapper,
  [`mcom-book-spa/components/flyoutcontainer`]: FlyoutDrawer,
  [`mi-aem-account/components/content/accountcontainer`]: AccountContainerEditable,
  [`mi-aem-account/components/content/signin`]: SignInEditable,
  [`mi-aem-account/components/content/signincontentblock`]: SignInContentBlockEditable,
  [`mi-aem-account/components/content/datapagecomponent`]: Container,
};

export const AEM_REACT_TITLE_MAPPING = {
  'mi-aem-common-spa/components/text': 'Text',
  'mi-aem-common-spa/components/title': 'Title',
  'mi-aem-common-spa/components/image': 'Image',
  'mi-aem-common-spa/components/experiencefragment': 'Experience Fragment',
  'mi-aem-common-spa/components/common/staticwrapper': 'Static Wrapper',
  'mi-aem-common-spa/components/content/globalnav/global-navigation': 'Global Navigation',
  'mi-aem-common-spa/components/content/globalnav/utilityNavigation': 'Utility Navigation',
  'mi-aem-common-spa/components/content/globalnav/primaryNavigation': 'Primary Navigation',
  'mi-aem-common-spa/components/common/dynamicwrapper': 'Dynamic Wrapper',
  'mi-aem-common-spa/components/content/brandribbon': 'Brand Ribbon',
  'mi-aem-common-spa/components/content/accordioncontainer': 'Accordion Container',
  'mi-aem-common-spa/components/content/linklist': 'Link List',
  'mi-aem-common-spa/components/content/hero': 'Hero',
  'mi-aem-homepage-spa/components/content/herobanner': 'Homepage Hero Banner',
  'mi-aem-homepage-spa/components/content/universal-footer': 'Universal Footer',
  'mi-aem-common-spa/components/content/bannerlayered': 'Banner Layered',
  'mi-aem-common-spa/components/content/cardlayered': 'Card Layered',
  'mi-aem-common-spa/components/content/cardvertical': 'Card Vertical',
  'mi-aem-common-spa/components/content/cardhorizontalmini': 'Card Horizontal Mini-Standard',
  'mi-aem-common-spa/components/content/cardcarouselcontainer': 'Card Carousel Container',
  'mi-aem-common-spa/components/content/cardhorizontalfeature': 'Card Horizontal Feature',
  'mi-aem-common-spa/components/content/richtext': 'Rich Text',
  'mi-aem-groups/components/content/shoppingpages/sectionnavigation': 'Section Navigation',
  'mi-aem-groups/components/content/shoppingpages/imagebanner': 'Image Banner',
  'mi-aem-groups/components/content/groupsearchform': 'Search Form',
  'mi-aem-groups/components/content/groupsearch/searchresultsv2': 'Search Form V2',
  'mi-aem-groups/components/content/groupsearch/searchresults': 'Search Results',
  'mi-aem-groups/components/content/rfp/rfptray': 'RFP Tray',
  'mi-aem-groups/components/content/rfp/header': 'RFP - Header',
  'mi-aem-groups/components/content/rfp/eventprofile': 'RFP - Event Profile',
  'mi-aem-groups/components/content/rfp/eventdetails': 'RFP - Event Details',
  'mi-aem-groups/components/content/rfp/contactinformation': 'Contact Information',
  'mi-aem-groups/components/content/rfp/confirmation': 'RFP - Confirmation',
  'mi-aem-groups/components/content/rfp/eventinfoheader': 'RFP - Event Info Header',
  'mi-aem-groups/components/content/rfp/eventinfo': 'RFP - Event Info',
  'mi-aem-groups/components/content/rfp/paymentheader': 'RFP - Preferred Payment Header',
  'mi-aem-groups/components/content/rfp/preferredpayment': 'RFP - Preferred Payment Method',
  'mi-aem-groups/components/content/rfp/cardInformation': 'RFP - Card Information',
  'mi-aem-groups/components/content/rfp/preferredpaymentconfirmation': 'Preferred Payment - Confirmation',
  'mi-aem-groups/components/content/roominglist/associateheader': 'Rooming List Associate - Header',
  'mi-aem-groups/components/content/roominglist/roominglistlogin': 'Rooming List - Login',
  'mi-aem-groups/components/content/roominglist/contenttiles': 'Rooming List - Content Tile',
  'mi-aem-groups/components/content/roominglist/searchandfilters': 'Rooming List - Search And Filter',
  'mi-aem-groups/components/content/roominglist/createeventsummary': 'Rooming List - Create Event Summary',
  'mi-aem-groups/components/content/roominglist/modifyeventsummary': 'Rooming List - View Modify Event',
  'mi-aem-groups/components/content/roominglist/eventsummarylist': 'Rooming List - Event Summary List',
  'mi-aem-groups/components/content/roominglist/revieweventsummary': 'Rooming List - Review Event Summary',
  'mi-aem-groups/components/content/roominglist/planner/plannerheader': 'Planner - Header',
  'mi-aem-groups/components/content/roominglist/planner/plannerlogin': 'Planner Portal - Login',
  'mi-aem-groups/components/content/roominglist/planner/eventheading': 'Event Heading',
  'mi-aem-groups/components/content/roominglist/planner/search': 'Planner Portal - Search',
  'mi-aem-groups/components/content/roominglist/planner/plannereventlist': 'Planner Portal - Event Summary List',
  'mi-aem-groups/components/content/roominglist/planner/plannernewevent': 'Planner - New Event',
  'mi-aem-groups/components/content/roominglist/notification': 'Rooming List - Notification',
  'mi-aem-groups/components/content/reslink/reslinkguest': 'ResLink Guest - Hotel Cards List',
  'mi-aem-groups/components/content/reslink/reslinkheader': 'Reslink - Header',
  'mi-aem-groups/components/content/reslink/contenttile': 'ResLink - Content Tile',
  'mi-aem-groups/components/content/reslink/searchandfilters': 'ResLink - Search And Filter',
  'mi-aem-groups/components/content/reslink/reslinklist': 'ResLink - List',
  'mi-aem-groups/components/content/reslink/eventdetails': 'ResLink - Event Details',
  'mi-aem-groups/components/content/common/emailform': 'Email Form',
  'mi-aem-groups/components/content/common/generalerror': 'General Error',
  'mi-aem-groups/components/content/common/reslinksubmitinvalid': 'ResLink - Submit Invalid',
  'mi-aem-groups/components/content/quickgroup/propertycardheader': 'Quick Group - Property Header',
  'mi-aem-groups/components/content/quickgroup/header': 'Quick Group - Header',
  'mi-aem-groups/components/content/quickgroup/guestrooms': 'Quick group - Guest Rooms',
  'mi-aem-groups/components/content/quickgroup/eventspaces': 'Quick Group - Event Spaces',
  'mi-aem-groups/components/content/quickgroup/eventreview': 'Quick Group - Event Review',
  'mi-aem-groups/components/content/quickgroup/billingandcontact': 'Quick Group - Billing and Contact',
  'mi-aem-groups/components/content/quickgroup/submitenquiry': 'Quick Group - Submit Enquiry',
  'mi-aem-groups/components/content/quickgroup/confirmation': 'Quick Group - Confirmation',
  'mi-aem-groups/components/content/quickgroup/invalidsession': 'Quick Group - Invalid Session',
  'mi-aem-groups/components/content/quickgroup/eventconfirmationdetails': 'Quick Group - Event Confirmation Details',
  'mi-aem-groups/components/content/quickgroup/resubmitrfp': 'Quick Group - Resubmit RFP',
  'mi-aem-homepage-spa/components/content/global-navigation': 'Global Navigation',
  'mi-aem-homepage-spa/components/content/utilityNavigation': 'Utility Navigation',
  'mi-aem-homepage-spa/components/content/primaryNavigation': 'Primary Navigation',
  'mcom-book-spa/components/flyoutcontainer': 'Flyout Container',
  'mi-aem-account/components/content/accountcontainer': 'Account Container',
  'mi-aem-account/components/content/signin': 'Sign In',
  'mi-aem-account/components/content/signincontentblock': 'Sign In Content Block',
  'mi-aem-account/components/content/datapagecomponent': 'Data Page Component',
};

export const getAllowedComponentsForNonAuthorMode = model => {
  return getAllowedComponentsForNonAuthorModeUtil(model, AEM_REACT_MAPPING, AEM_REACT_TITLE_MAPPING);
};

export const defineComponentMapping = (
  allowedComponents,
  pagePath,
  isAuthorMode,
  locale,
  isDtt,
  isRTL,
  isDttSwpGroupsEnabled
) => {
  const logger = global.loggerInstance?.('defineComponentMapping');
  const log = logger?.log || (() => {});
  const logError = logger?.error || (() => {});

  try {
    MapTo(`mi-aem-common-spa/components/text`)(Text);
    MapTo(`mi-aem-common-spa/components/title`)(Heading);
    MapTo(`mi-aem-common-spa/components/image`)(Container);

    // Import not working so temporary solution
    // Need to remove once platform resolves the import issue
    const ExperienceFragmentVariationConfig = {
      emptyLabel: 'Experience Fragment',
      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-common-spa/components/experiencefragment')(props => {
      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={respGridUtil(props?.model?.cqItems?.root?.[':items']?.responsivegrid)}
        />
      );
    }, ExperienceFragmentVariationConfig);

    MapTo(`mi-aem-common-spa/components/common/staticwrapper`)(StaticWrapper, {
      emptyLabel: 'StaticWrapper',
      isEmpty: false,
    });
    MapTo(`mi-aem-common-spa/components/content/globalnav/global-navigation`)(props => (
      <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-common-spa/components/content/globalnav/utilityNavigation`)(NavigationUtilityLinkWrapper);
    MapTo(`mi-aem-common-spa/components/content/globalnav/primaryNavigation`)(NavigationWrapper);
    MapTo(`mi-aem-common-spa/components/common/dynamicwrapper`)(props => (
      <DynamicWrapper {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-common-spa/components/content/brandribbon`)(BrandRibbon);
    MapTo(`mi-aem-common-spa/components/content/accordioncontainer`)(props => (
      <AccordionContainer {...props} isAuthorMode={isAuthorMode} allowedComponents={allowedComponents} />
    ));
    MapTo(`mi-aem-common-spa/components/content/linklist`)(LinkList);
    MapTo(`mi-aem-common-spa/components/content/hero`)(Hero);
    MapTo(`mi-aem-homepage-spa/components/content/herobanner`)(HeroBanner);
    MapTo(`mi-aem-homepage-spa/components/content/universal-footer`)(props => (
      <Footer {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-common-spa/components/content/bannerlayered`)(BannerLayered);
    MapTo(`mi-aem-common-spa/components/content/cardlayered`)(CardLayered);
    MapTo(`mi-aem-common-spa/components/content/cardvertical`)(CardVertical);
    MapTo(`mi-aem-common-spa/components/content/cardhorizontalmini`)(CardHorizontalMini);
    MapTo(`mi-aem-common-spa/components/content/richtext`)(RichText);
    MapTo(`mi-aem-common-spa/components/content/cardcarouselcontainer`)(props => (
      <CardCarouselContainer
        {...props}
        isAuthorMode={isAuthorMode}
        allowedComponents={allowedComponents}
        rtlEnable={isRTL}
      />
    ));
    MapTo(`mi-aem-common-spa/components/content/cardhorizontalfeature`)(CardHorizontalFeature);
    MapTo(`mi-aem-groups/components/content/shoppingpages/sectionnavigation`)(NavigationMenu);
    MapTo(`mi-aem-groups/components/content/shoppingpages/imagebanner`)(ImageBanner);
    MapTo(`mi-aem-groups/components/content/groupsearchform`)(props =>
      isAuthorMode ? <GroupSearchForm {...props} /> : <GroupSearchFormDynamic {...props} />
    );
    MapTo(`mi-aem-groups/components/content/groupsearch/searchresultsv2`)(props =>
      isAuthorMode ? <SearchForm {...props} /> : <SearchFormDynamic {...props} />
    );
    MapTo(`mi-aem-groups/components/content/groupsearch/searchresults`)(props => (
      <SearchResults {...props} locale={locale} />
    ));
    MapTo(`mi-aem-groups/components/content/rfp/rfptray`)(RfpTray);
    MapTo(`mi-aem-groups/components/content/rfp/header`)(RfpHeader);
    MapTo(`mi-aem-groups/components/content/rfp/eventprofile`)(EventProfile);
    MapTo(`mi-aem-groups/components/content/rfp/eventdetails`)(EventDetails);
    MapTo(`mi-aem-groups/components/content/rfp/contactinformation`)(ContactInfo);
    MapTo(`mi-aem-groups/components/content/rfp/confirmation`)(RfpConfirmation);
    MapTo(`mi-aem-groups/components/content/rfp/eventinfoheader`)(IntlRfpHeader);
    MapTo(`mi-aem-groups/components/content/rfp/eventinfo`)(IntlRfpEventInfo);
    MapTo(`mi-aem-groups/components/content/rfp/paymentheader`)(PreferredPaymentHeader);
    MapTo(`mi-aem-groups/components/content/rfp/preferredpayment`)(PreferredPaymentInfo);
    MapTo(`mi-aem-groups/components/content/rfp/cardInformation`)(PaymentInfo);
    MapTo(`mi-aem-groups/components/content/rfp/preferredpaymentconfirmation`)(PreferredPaymentConfirmation);
    MapTo(`mi-aem-groups/components/content/roominglist/associateheader`)(AssociateHeader);
    MapTo(`mi-aem-groups/components/content/roominglist/roominglistlogin`)(AssociateLogin(isDtt));
    MapTo(`mi-aem-groups/components/content/roominglist/contenttiles`)(DashboardContentTiles);
    MapTo(`mi-aem-groups/components/content/roominglist/searchandfilters`)(SearchAndFilter);
    MapTo(`mi-aem-groups/components/content/roominglist/createeventsummary`)(CreateEventSummary);
    MapTo(`mi-aem-groups/components/content/roominglist/modifyeventsummary`)(ModifyEventSummary);
    MapTo(`mi-aem-groups/components/content/roominglist/eventsummarylist`)(EventSummaryList(isDtt));
    MapTo(`mi-aem-groups/components/content/roominglist/revieweventsummary`)(ConfirmEventSummary(isDtt));
    MapTo(`mi-aem-groups/components/content/roominglist/planner/plannerheader`)(PlannerHeader);
    MapTo(`mi-aem-groups/components/content/roominglist/planner/plannerlogin`)(PlannerLogin);
    MapTo(`mi-aem-groups/components/content/roominglist/planner/eventheading`)(EventHeading);
    MapTo(`mi-aem-groups/components/content/roominglist/planner/search`)(EventSearch);
    MapTo(`mi-aem-groups/components/content/roominglist/planner/plannereventlist`)(PlannerEventList(isDtt));
    MapTo(`mi-aem-groups/components/content/roominglist/planner/plannernewevent`)(PlannerNewEvent(isDtt));
    MapTo(`mi-aem-groups/components/content/roominglist/notification`)(BulletinBoard);
    MapTo(`mi-aem-groups/components/content/reslink/reslinkheader`)(ReslinkAssociateHeader);
    MapTo(`mi-aem-groups/components/content/reslink/contenttile`)(ReslinkDashboardContentTiles);
    MapTo(`mi-aem-groups/components/content/reslink/searchandfilters`)(ReslinkSearchAndFilter);
    MapTo(`mi-aem-groups/components/content/reslink/reslinklist`)(EventList(isDtt));
    MapTo(`mi-aem-groups/components/content/reslink/eventdetails`)(ReslinkEventDetails(isAuthorMode, isDtt));
    MapTo(`mi-aem-groups/components/content/reslink/reslinkguest`)(ReslinkGuest(isDtt));
    MapTo(`mi-aem-groups/components/content/common/emailform`)(ReslinkEmailInfo(isDtt));
    MapTo(`mi-aem-groups/components/content/common/generalerror`)(GeneralError);
    MapTo(`mi-aem-groups/components/content/common/reslinksubmitinvalid`)(GeneralMessage);
    MapTo(`mi-aem-groups/components/content/quickgroup/propertycardheader`)(PropertyHeader);
    MapTo(`mi-aem-groups/components/content/quickgroup/header`)(QuickGroupHeader);
    MapTo(`mi-aem-groups/components/content/quickgroup/guestrooms`)(props => {
      const GuestRoomsComponent = GuestRooms(isDttSwpGroupsEnabled);
      return <GuestRoomsComponent {...props} isAuthorMode={isAuthorMode} />;
    });
    MapTo(`mi-aem-groups/components/content/quickgroup/eventspaces`)(props => (
      <EventSpaces {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-groups/components/content/quickgroup/eventreview`)(Review);
    MapTo(`mi-aem-groups/components/content/quickgroup/billingandcontact`)(BillingAndContact);
    MapTo(`mi-aem-groups/components/content/quickgroup/submitenquiry`)(SubmitInquiry);
    MapTo(`mi-aem-groups/components/content/quickgroup/confirmation`)(QuickGroupConfirmation);
    MapTo(`mi-aem-groups/components/content/quickgroup/invalidsession`)(InvalidSession);
    MapTo(`mi-aem-groups/components/content/quickgroup/eventconfirmationdetails`)(EventConfirmationDetails);
    MapTo(`mi-aem-groups/components/content/quickgroup/resubmitrfp`)(ResubmitRfp);
    MapTo(`mi-aem-homepage-spa/components/content/global-navigation`)(props => (
      <NavigationContainerWrapper {...props} isAuthorMode={isAuthorMode} />
    ));
    MapTo(`mi-aem-homepage-spa/components/content/utilityNavigation`)(NavigationUtilityLinkWrapper);
    MapTo(`mi-aem-homepage-spa/components/content/primaryNavigation`)(NavigationWrapper);

    MapTo(`mcom-book-spa/components/flyoutcontainer`)(
      props => <FlyoutDrawer {...props.model} {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'FlyoutDrawer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/accountcontainer`)(
      props => <AccountContainerEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'accountcontainer',
        isEmpty: false,
      }
    );
    MapTo(`mi-aem-account/components/content/signin`)(
      props => <SignInEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signin',
      }
    );
    MapTo(`mi-aem-account/components/content/signincontentblock`)(
      props => <SignInContentBlockEditable {...props} isAuthorMode={isAuthorMode} />,
      {
        emptyLabel: 'signincontentblock',
      }
    );
    const DataPageVariationConfig = {
      emptyLabel: 'Data Page',

      isEmpty: function (props) {
        return !props || !props.configured;
      },
    };
    MapTo('mi-aem-account/components/content/datapagecomponent')(props => {
      const gridItems = props?.model?.cqItems?.responsivegrid?.[':items'];
      const isAccountContainer = gridItems ? Object.keys(gridItems)?.[0]?.includes('accountcontainer') : false;

      return (
        <Container
          isInEditor
          {...props}
          isPage={false}
          model={isAccountContainer ? respGridUtil(props?.model?.cqItems?.responsivegrid) : props?.model}
        />
      );
    }, DataPageVariationConfig);

    const existingMappings = Object.keys(AEM_REACT_MAPPING);

    // Validate allowedComponents before processing
    if (allowedComponents && Array.isArray(allowedComponents)) {
      let successCount = 0;
      let failureCount = 0;

      allowedComponents.forEach((mapping, index) => {
        try {
          // Validate mapping object structure
          if (!mapping || typeof mapping !== 'object') {
            throw new Error(`Invalid mapping object at index ${index}`);
          }

          if (!mapping.path || typeof mapping.path !== 'string') {
            throw new Error(`Invalid or missing path in mapping at index ${index}`);
          }

          const baseModelPath = '/jcr:content/root/responsivegrid/';
          const componentPath = mapping.path.replace(pagePath, '').replace(baseModelPath, '');

          if (!componentPath) {
            throw new Error(`Unable to extract component path from: ${mapping.path}`);
          }

          if (existingMappings.indexOf(componentPath) === -1) {
            MapTo(componentPath)(EditableHTLWrapper, {
              emptyLabel: mapping.title || 'Component',
              isEmpty: false,
            });
            successCount++;
          } else {
            if (process.env.NODE_ENV === 'development') {
              log('Mapping already exists, skipping:', componentPath);
            }
          }
        } catch (mappingError) {
          failureCount++;
          if (process.env.NODE_ENV === 'development') {
            logError(`Failed to map component at index ${index}:`, {
              error: mappingError.message,
              mapping: mapping,
              stack: mappingError.stack,
            });
          }
          // Continue processing remaining components
        }
      });

      if (process.env.NODE_ENV === 'development') {
        log(
          `Component mapping complete. Success: ${successCount}, Failed: ${failureCount}, Total: ${allowedComponents.length}`
        );
      }
    } else if (process.env.NODE_ENV === 'development') {
      log('No allowed components provided or invalid format');
    }
  } catch (err) {
    // Always log errors regardless of environment - use your server logger, not console
    logError('Critical error in defineComponentMapping:', {
      error: err.message,
      stack: err.stack,
    });
    // Re-throw so the caller (page bootstrap) can decide recovery strategy.
    // Silent failure here means EVERY AEM component renders as blank with zero observability.
    throw err;
  }
};
